import { useMutation } from '@tanstack/react-query';
import { regeneratePartnerAvatarFromFile } from '../services/regeneratePartnerMedia';

/** POST /admin/partner/regenerate-avatar */
export const useRegeneratePartnerAvatarMutation = (options = {}) => {
  return useMutation({
    mutationKey: ['regenerate-partner-avatar'],
    mutationFn: ({ file, signal }) => regeneratePartnerAvatarFromFile(file, { signal }),
    ...options,
  });
};
